// Runtime-only constants extracted from i18n.ts so they can be imported by
// `.mjs` files loaded by raw Node — Next 15's static-generation workers load
// `frontend-next/cache-handler.mjs` (and its transitively-imported helpers)
// without webpack, so a `.ts` import there fails with
// "TypeError: Unknown file extension '.ts'".
//
// `i18n.ts` re-exports these so TS callers continue to use `@mw/shared/i18n`
// unchanged. JSDoc preserves the literal types `as const` would have given.

/** @type {"en"} */
export const DEFAULT_LANGUAGE = "en";

/** @type {readonly ["hi", "es", "de", "fr", "it", "ja", "ko", "pl", "sv", "pt", "zh"]} */
export const TARGET_LANGUAGES = /** @type {const} */ ([
  "hi",
  "es",
  "de",
  "fr",
  "it",
  "ja",
  "ko",
  "pl",
  "sv",
  "pt",
  "zh",
]);
